import { gql } from '@apollo/client'
import {
  OrbitalTrackLiteFragment,
  OrbitalTrackSettingFragment
} from '@src/graphql/fragment/orbitalTrack'
import { StarLiteFragment } from '@src/graphql/fragment/star'

export default gql`
  query GetOrbitalTrackDetail($starId: String!) {
    getOrbitalTrackDetail(starID: $starId) {
      star {
        ...StarLite
      }
      totalOrbitalTrackCount
      availableOrbitalTrackCount
      openSetting {
        ...OrbitalTrackSetting
      }
      inviteSettings {
        ...OrbitalTrackSetting
      }
      tracks {
        ...OrbitalTrackLite
      }
      ownerTracks {
        ...OrbitalTrackLite
      }
    }
  }
  ${StarLiteFragment}
  ${OrbitalTrackSettingFragment}
  ${OrbitalTrackLiteFragment}
`
